import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'
import { reduce } from 'lodash'

const languages = (process.env.TRANSLATIONS_LANGUAGES || '').split(',').filter(Boolean)

export const AosUserLocalisation = reduce(
    languages,
    (acc, lang) => {
        acc[lang] = lang
        return acc
    },
    {} as Record<string, string>,
)

export type AosUserLocalisation = (typeof AosUserLocalisation)[number]

export const languageOptions = EnumValues.getValues<AosUserLocalisation>(AosUserLocalisation)

export const languageName = (translate: TFunction) => (u: AosUserLocalisation) =>
    translate(`languages.${u}`, { ns: 'common' })
